module.exports = __webpack_public_path__ + "static/media/individual-home.efa3b83b.png";